/* eslint-disable */
import {extendDecorator, viewModelDecorator} from '@/js/common/Domain/Service/mixins/decorators';
import template from './template.html';

@viewModelDecorator({
    directFlight: false,
    isDirectFlightAllowed: false,
})
@extendDecorator({
    template,
    bindings: {
        label: 'classes: {checked:directFlight}',
        input: 'checked: directFlight',
    },
})
export default class DirectFlightView extends Backbone.Epoxy.View {
    initialize() {
        this.initModelEvents();
        this.render();
    }

    initModelEvents() {
        this.viewModel.mapState({
            directFlight: 'model',
        }, this.model);

        this.viewModel.on('change:directFlight', (model, value) => {
            this.model.set({
                model: value,
            }, {initiator: 'view'});
        });
    }

    render() {
        this.$el.html(template());
    }
}